import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../common/Checkbox';

const SummaryCheckbox = ({ summaryCheckboxValue, onSummaryCheckboxValueChange, disabled }) => (
  <Checkbox
    small
    className="u-mr0"
    disabled={disabled}
    value={summaryCheckboxValue}
    checked={!!summaryCheckboxValue}
    onChange={onSummaryCheckboxValueChange}
  />
);

SummaryCheckbox.propTypes = {
  disabled: PropTypes.bool.isRequired,
  summaryCheckboxValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.symbol]).isRequired,
  onSummaryCheckboxValueChange: PropTypes.func.isRequired,
};

export default SummaryCheckbox;
